// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"46599a22","230":"3a64b325","246":"73f3898f","440":"73cebb1c","453":"2c48688c","467":"f2643c66","547":"73cebb1c"}[chunkId] + ".css";
};